import { useState } from 'react';
import './style.scss';
import { TranslationService } from '../../../../services/translation.service';
import checkCircleGreen from '../../../../../assets/icons/check-circle-green.svg';
import timesCircleRed from '../../../../../assets/icons/times-circle-red.svg';
import DataUrlHelper from '../../../../helpers/data-url.helper';

enum CopyStatus {
  notperformed = 'notperformed',
  hidden = 'hidden',
  success = 'success',
  failed = 'error',
}

function CopyInput({ inputValue, inputId }: { inputValue: string | undefined; inputId: string }) {
  const [copyStatus, setCopyStatus] = useState(CopyStatus.notperformed);
  const [copyStatusText, setCopyStatusText] = useState('');
  const secondsToShowCopyStatus = 5;

  function hideCopyStatusWithDelay() {
    setTimeout(() => {
      setCopyStatus(CopyStatus.hidden);
    }, secondsToShowCopyStatus * 1000);
  }

  function handleButtonClick() {
    // Support for older browsers (i.e. IE and Safari on iOS < 13.4) removed
    // See https://caniuse.com/mdn-api_navigator_clipboard

    if (inputValue) {
      setCopyStatus(CopyStatus.notperformed);
      navigator.clipboard
        .writeText(inputValue)
        .then(() => {
          setCopyStatus(CopyStatus.success);
          setCopyStatusText(TranslationService.get('departureboardlinkgeneratorpage.tooltipmessage'));
        })
        .catch(() => {
          setCopyStatus(CopyStatus.failed);
          setCopyStatusText(TranslationService.get('departureboardlinkgeneratorpage.failedtocopytext'));
        })
        .finally(() => {
          hideCopyStatusWithDelay();
        });
    }
  }

  return (
    <div className="copy-input">
      <label htmlFor={inputId} className="form-label">
        {TranslationService.get('departureboardlinkgeneratorpage.yourlinklabel')}
      </label>
      <div className="input-group mb-2">
        <input
          type="text"
          className="form-control input-box"
          id={inputId}
          name={inputId}
          value={inputValue}
          aria-label={TranslationService.get('departureboardlinkgeneratorpage.yourlinklabel')}
          readOnly
        />
        <button className="btn btn-primary py-0" onClick={handleButtonClick}>
          {TranslationService.get('departureboardlinkgeneratorpage.copylinktext')}
        </button>
      </div>
      <div aria-live="polite">
        {(copyStatus === CopyStatus.success || copyStatus === CopyStatus.failed) && (
          <div className={`d-flex flex-row ${copyStatus === CopyStatus.failed ? 'status--red' : 'status--green'}`}>
            <img className="copy-input__icon pe-1" alt="" src={DataUrlHelper.encode(copyStatus === CopyStatus.failed ? timesCircleRed : checkCircleGreen)} />
            <div>{copyStatusText}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CopyInput;
